// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__cRJlB","logo":"styles_logo__3OtxC","sec1":"styles_sec1__3_Pq0","socials":"styles_socials__3uSBJ","copyright":"styles_copyright__1JsuA"};